import axios from "axios";

import { NProgress } from "@/plugins/nprogress";

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

http.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

http.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  async (error: unknown) => {
    NProgress.done();

    if (axios.isAxiosError(error) && error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes("/login");
      const isCurrentUserRequest = error.config?.url?.includes("/api/user");

      if (!isLoginRequest && !isCurrentUserRequest) {
        const { useAuthStore } = await import("@/features/auth/auth.store");
        const router = (await import("@/router")).default;

        const auth = useAuthStore();
        auth.user = null;
        auth.hasCheckedAuth = true;

        await router.push("/login");
      }
    }

    return Promise.reject(error);
  },
);
